import React from 'react';
import __ from 'lodash';

class DropdownKodeJenjangSekolah extends React.Component {
    render() { 
        return ( 
            <>
                <option key="SD" value="SD">SD</option>
                <option key="SMP" value="SMP">SMP</option>
                <option key="SMA" value="SMA">SMA</option>
                <option key="SMK" value="SMK">SMK</option>
                <option key="MI" value="MI">MI</option>
                <option key="MTs" value="MTs">MTs</option>
                <option key="MA" value="MA">MA</option>
            </>
        );
    }
}
 
export default DropdownKodeJenjangSekolah;